export const permissions = {
  my: [],
  // RescueNetCompanyPermissions
  rnc: [],
  // PermissionsForRescueNetApplicant
  rna: [],
  // Authorized Products
  products: [],
};
